export enum UnitType {
  MM = 'mm',
  CM = 'cm',
  CM_SEC = 'cm/sec',
  CM2 = 'cm²',
  BPM = 'BPM',
  PERCENTAGE = '%',
}

export default UnitType;
